export default {
	namespaced: true,
	state: {
		reloadState: true,
		sessionUserinfo: {},
	},
	mutations: {
		setReloadState(state, reloadState) {
			state.reloadState = reloadState;
			if(reloadState) {
				state.sessionUserinfo = {};
			}
		},
		setSessionUserinfo(state, sessionUserinfo) {
			state.sessionUserinfo = sessionUserinfo;
		},
	},
	getters: {
		getReloadState(state) {
			return state.reloadState;
		},
		SESSION_USERINFO(state) {
			return state.sessionUserinfo;
		},
	},
};
